<template>
    <img class="z-0 fixed opacity-[10%] top-40 lg:h-[450px] lg:right-26 lg:top-24 2xl:h-[610px] 2xl:right-38 2xl:top-32" src="@/assets/img/logo-bhgk.png" alt="Logo BHGK">
    
    <app-beranda-saran-masukan :isModalOpen="isSaranModalOpen" @onModalCloses="closeSaranModal" />

    <app-beranda-ubah-password :isModalOpen="isUbahPasswordOpen" @onModalCloses="closeUbahPasswordModal" />

    <modal v-model:visible="visible.bhgk" centered width="93%">
        <div class="container">
            <div class="row align-items-center mt-3 mb-5">
                <div class="col-md-12 text-center">
                    <h4 class="w-fit m-auto text-white">{{ (lang == 'en' ? 'Internal Service BHGK' : 'Layanan Internal BHGK') }}</h4>
                </div>
            </div>
            <div v-for="c in groupAppsBhgk" :key="c" class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-x-3 gap-y-3 lg:gap-y-0 border !border-[rgb(255,255,255,15%)] bg-[rgb(255,255,255,5%)] rounded-lg px-3 py-2 my-2">
                <a v-for="item in appsBhgk.filter(app => app.subcategory_id === c)" :key="item.id" :href="getUrlLayanan(item)" target="_blank" class="!rounded-lg !bg-[#07213A] hover:!bg-[#FFF] py-3 px-1.5 group relative cursor-pointer w-full text-left">
                    <div class="flex justify-center items-center">
                        <img v-lazy="fstring.getAssetpath(item.image)" class="h-8 sm:h-10 w-auto max-w-24 object-contain transition-all duration-250 group-hover:scale-110 group-hover:rotate-4 z-10" alt="Icon Layanan">
                        <div class="absolute bg-white rounded-full h-8 sm:h-10 w-8 sm:w-10"></div>
                    </div>
                    <h6 class="text-white !text-xs text-center group-hover:!text-[#3B2B99] !mt-4 !mb-0">{{ (item?.title ?? '') }}</h6>
                </a>
            </div>
        </div>

        <template #footer>
        </template>
    </modal>

    <modal v-model:visible="visible.pu" centered width="93%">
        <div class="container">
            <div class="row align-items-center mt-3 mb-5">
                <div class="col-md-12 text-center">
                    <h4 class="w-fit m-auto text-white">{{ (lang == 'en' ? 'Ministry of Public Works Service' : 'Layanan Kementerian Pekerjaan Umum') }}</h4>
                </div>
            </div>
            <div v-for="c in groupAppsPu" :key="c" class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-x-3 gap-y-3 lg:gap-y-0 border !border-[rgb(255,255,255,15%)] bg-[rgb(255,255,255,5%)] rounded-lg px-3 py-2 my-2">
                <a v-for="item in appsPu.filter(app => app.subcategory_id === c)" :key="item.id" :href="getUrlLayanan(item)" target="_blank" class="!rounded-lg !bg-[#07213A] hover:!bg-[#FFF] py-3 px-1.5 group relative cursor-pointer w-full text-left">
                    <div class="flex justify-center items-center">
                        <img v-lazy="fstring.getAssetpath(item.image)" class="h-8 sm:h-10 w-auto max-w-24 object-contain transition-all duration-250 group-hover:scale-110 group-hover:rotate-4 z-10" alt="Icon Layanan">
                        <div class="absolute bg-white rounded-full h-8 sm:h-10 w-8 sm:w-10"></div>
                    </div>
                    <h6 class="text-white !text-xs text-center group-hover:!text-[#3B2B99] !mt-4 !mb-0">{{ (item?.title ?? '') }}</h6>
                </a>
            </div>
        </div>

        <template #footer>
        </template>
    </modal>

    <modal v-model:visible="visible.eksternal" centered width="93%">
        <div class="container">
            <div class="row align-items-center mt-3 mb-5">
                <div class="col-md-12 text-center">
                    <h4 class="w-fit m-auto text-white">{{ (lang == 'en' ? 'Other Ministries Service' : 'Layanan Kementerian/Lembaga Lainnya') }}</h4>
                </div>
            </div>
            <div v-for="c in groupAppsEksternal" :key="c" class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-x-3 gap-y-3 lg:gap-y-0 border !border-[rgb(255,255,255,15%)] bg-[rgb(255,255,255,5%)] rounded-lg px-3 py-2 my-2">
                <a v-for="item in appsEksternal.filter(app => app.subcategory_id === c)" :key="item.id" :href="getUrlLayanan(item)" target="_blank" class="!rounded-lg !bg-[#07213A] hover:!bg-[#FFF] py-3 px-1.5 group relative cursor-pointer w-full text-left">
                    <div class="flex justify-center items-center">
                        <img v-lazy="fstring.getAssetpath(item.image)" class="h-8 sm:h-10 w-auto max-w-24 object-contain transition-all duration-250 group-hover:scale-110 group-hover:rotate-4 z-10" alt="Icon Layanan">
                        <div class="absolute bg-white rounded-full h-8 sm:h-10 w-8 sm:w-10"></div>
                    </div>
                    <h6 class="text-white !text-xs text-center group-hover:!text-[#3B2B99] !mt-4 !mb-0">{{ (item?.title ?? '') }}</h6>
                </a>
            </div>
        </div>

        <template #footer>
        </template>
    </modal>

    <section class="directory-section bg-new px-5 !py-5">
        <img src="@/assets/img/logo-bhgk-pu-full-white.png" class="img-fluid mt-1.5 !h-[32px] md:!h-[56px] w-auto object-contain" alt="Logo">

        <a v-if="!usersData" :href="`${cmsUrl}/adminpanel/#/login`" class="absolute right-12 top-6 !rounded-full border font-medium !border-[#095066] px-4 py-1.5 !text-white !bg-[#354775] transition-all duration-150 hover:!bg-[#FFC928] hover:!text-[#354775]">Login</a>

        <div v-else class="language-dropdown group absolute right-12 top-6 !rounded-full border font-medium !border-[#095066] px-3 py-1.5 !text-white !bg-[#354775] transition-all duration-150 hover:!bg-[#FFC928] hover:!text-[#354775]" ref="dropdownProfile">
            <button class="dropdown-toggle text-white font-bold !text-sm !space-x-1.5" @click="toggleDropdownProfile"
            aria-label="dropdown">
            <i class="group-hover:!text-[#095066] fa fa-user text-white !text-xs"></i>
            <span class="group-hover:!text-[#095066] font-normal text-xs">{{ usersData?.name }}</span>
            <i class="group-hover:!text-[#095066] feather-chevron-down text-white"></i>
            </button>
            <div class="dropdown-menu" v-if="isDropdownProfileOpen">
                <div @click="openUbahPasswordModal" class="cursor-pointer dropdown-item">
                    <div class="language-info">
                        <div class="country-name">Ubah Kata Sandi</div>
                    </div>
                </div>
                <div @click="onLogout" class="cursor-pointer dropdown-item">
                    <div class="language-info">
                        <div class="country-name">Keluar</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container pt-4 pb-2">
            <template v-if="!visible.bhgk && !visible.pu && !visible.eksternal && !isSaranModalOpen && !isUbahPasswordOpen">
                <div class="section-heading heading-eight w-fit m-auto mb-4">
                    <div class="row align-items-center">
                        <div class="col-md-12 text-center">
                            <h5 class="text-white !font-light">Selamat Datang di</h5>
                            <h3 class="text-white !text-4xl !font-bold mb-0">BHGK Collaboration</h3>
                        </div>
                    </div>
                </div>
                <hr class="!mb-6 w-1/4 mx-auto !border-white">
                <div class="category-details">
                    <div class="row space-y-4">
                        <div class="offset-lg-4 col-lg-4 offset-md-3 col-md-6 d-flex justify-center">
                            <a class="card-infografis !rounded-lg !bg-[#07213A] hover:!bg-[#FFF] py-4 group relative cursor-pointer flex flex-row items-center justify-between w-full text-left" href="javascript:void(0)" @click="showModalBhgk">
                                <div class="category-content">
                                    <h6 class="!text-white !font-normal group-hover:!text-[#3B2B99] mb-0">Internal BHGK</h6>
                                </div>
                                <img v-lazy="'assets/images/icons/icon-layanan-bhgk.png'" class="dir-icon brightness-[100] group-hover:brightness-[1] !w-13 2xl:!w-16 !h-13 2xl:!h-16 transition-all duration-250 group-hover:scale-110 group-hover:rotate-4" alt="ciptakarya">
                            </a>
                        </div>
                        <div class="offset-lg-4 col-lg-4 offset-md-3 col-md-6 d-flex justify-center">
                            <a class="card-infografis !rounded-lg !bg-[#07213A] hover:!bg-[#FFF] py-4 group relative cursor-pointer flex flex-row items-center justify-between w-full text-left" href="javascript:void(0)" @click="showModalPu">
                                <div class="category-content">
                                    <h6 class="!text-white !font-normal group-hover:!text-[#3B2B99] mb-0">Kementerian Pekerjaan Umum</h6>
                                </div>
                                <img v-lazy="'assets/images/icons/icon-layanan-pu.png'" class="dir-icon brightness-[100] group-hover:brightness-[1] !w-13 2xl:!w-16 !h-13 2xl:!h-16 transition-all duration-250 group-hover:scale-110 group-hover:rotate-4" alt="ciptakarya">
                            </a>
                        </div>
                        <div class="offset-lg-4 col-lg-4 offset-md-3 col-md-6 d-flex justify-center">
                            <a class="card-infografis !rounded-lg !bg-[#07213A] hover:!bg-[#FFF] py-4 group relative cursor-pointer flex flex-row items-center justify-between w-full text-left" href="javascript:void(0)" @click="showModalEksternal">
                                <div class="category-content">
                                    <h6 class="!text-white !font-normal group-hover:!text-[#3B2B99] mb-0">Kementerian/Lembaga Lainnya</h6>
                                </div>
                                <img v-lazy="'assets/images/icons/icon-layanan-eksternal.png'" class="dir-icon brightness-[100] group-hover:brightness-[1] !w-13 2xl:!w-16 !h-13 2xl:!h-16 transition-all duration-250 group-hover:scale-110 group-hover:rotate-4" alt="ciptakarya">
                            </a>
                        </div>
                    </div>
                </div>

                <app-newsticker />
            </template>
        </div>

        <footer class="absolute bottom-5 flex flex-col md:flex-row items-center md:items-end justify-between w-[75%] md:w-[93%]">
            <p class="order-2 md:!order-1 mb-0 text-center md:text-left text-white">Hak Cipta &copy; 2025 Balai Hidrolika dan Geoteknik Keairan</p>
            <a href="javascript:void(0)" class="order-1 md:!order-2 mb-3 md:!mb-0 text-right !rounded-full border font-medium !border-[#095066] px-4 py-1.5 !text-white !bg-[#354775] transition-all duration-150 hover:!bg-[#FFC928] hover:!text-[#354775]" @click.prevent="openSaranModal">Saran dan Masukan</a>
        </footer>
    </section>
</template>

<script>
import { fstring } from '@/lib/fstring.js'
import { mapState, useStore } from 'vuex'
import { ref } from 'vue'
import { Modal } from 'ant-design-vue'
import AppBerandaSaranMasukan from '@/views/modules/main/section/beranda-saran-masukan.vue'
import AppBerandaUbahPassword from '@/views/modules/main/section/beranda-ubah-password.vue'
import AppNewsticker from '@/views/layouts/newsticker.vue'
import { getUrlLayanan } from '@/lib/utils'

export default {
    props: ['directoryData'],
    components: {
        Modal,
        AppBerandaSaranMasukan,
        AppBerandaUbahPassword,
        AppNewsticker,
    },
    setup() {
        const store = useStore()
        const visible = ref({
            bhgk: false,
            pu: false,
            eksternal: false,
        })

        const cmsUrl = process.env.VUE_APP_CMS_URL;

        const showModalBhgk = () => {
            visible.value.bhgk = true;
        };

        const showModalPu = () => {
            visible.value.pu = true;
        };

        const showModalEksternal = () => {
            visible.value.eksternal = true;
        };

        return {
            store,
            visible,
            cmsUrl,
            showModalBhgk,
            showModalPu,
            showModalEksternal,
            getUrlLayanan,
        }
    },
    data() {
        return {
            fstring: fstring,
            lang: fstring.getLang(),
            appsBhgk: [],
            appsPu: [],
            appsEksternal: [],
            isDropdownProfileOpen: false,
            isSaranModalOpen: false,
            isUbahPasswordOpen: false,
        };
    },
    methods: {
        openSaranModal() {
			this.isSaranModalOpen = true
		},
        closeSaranModal() {
			this.isSaranModalOpen = false
		},
        openUbahPasswordModal() {
			this.isUbahPasswordOpen = true
		},
        closeUbahPasswordModal() {
			this.isUbahPasswordOpen = false
		},
        toggleDropdownProfile() {
            this.isDropdownProfileOpen = !this.isDropdownProfileOpen;
        },
        handleClickOutside(event) {
            if (this.$refs.dropdownProfile && !this.$refs.dropdownProfile.contains(event.target)) {
                this.isDropdownProfileOpen = false;
            }
        },
        onLogout() {
            localStorage.removeItem('token')
            localStorage.removeItem('auth_token')
            localStorage.removeItem('users-info')
            sessionStorage.clear()
            this.$store.commit('homePage/SET_USER', { user: null, token: null })
            this.$router.go()
        }
    },
    computed: {
        ...mapState('homePage', {
            usersData: (state) => state.user,
        }),
        appsBhgk() {
            return this.directoryData.filter(item => item.category_id === '1').sort((a, b) => a.seq - b.seq);
        },
        groupAppsBhgk() {
            const uniqueSubcatId = new Set(this.directoryData.filter(item => item.category_id === '1').map(obj => obj.subcategory_id));
            return uniqueSubcatId.size;
        },
        appsPu() {
            return this.directoryData.filter(item => item.category_id === '2').sort((a, b) => a.seq - b.seq);
        },
        groupAppsPu() {
            const uniqueSubcatId = new Set(this.directoryData.filter(item => item.category_id === '2').map(obj => obj.subcategory_id));
            return uniqueSubcatId.size;
        },
        appsEksternal() {
            return this.directoryData.filter(item => item.category_id === '3').sort((a, b) => a.seq - b.seq);
        },
        groupAppsEksternal() {
            const uniqueSubcatId = new Set(this.directoryData.filter(item => item.category_id === '3').map(obj => obj.subcategory_id));
            return uniqueSubcatId.size;
        },
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    },
}
</script>

<style scoped>
.language-dropdown {
  /* position: relative; */
  display: flex;
}

.dropdown-toggle {
  background: transparent;
  border: none;
  color: #000;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.flag-icon {
  width: 36px;
  height: 36px;
  background-size: cover;
  margin-right: 4px;
  border: 2px solid #e0e0e0;
  border-radius: 99px;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: #07213A;
  border: 1px solid #ddd;
  border-radius: 8px;
  /* Rounded corners */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  width: 180px;
  /* Adjust width as needed */
  padding: 8px 0;
  /* Padding inside the card */
  z-index: 1000;
}

.dropdown-item {
  padding: 8px 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #FFF;
  border-bottom: 1px solid #ddd;
  transition: background-color 0.3s;

  &:hover {
    background-color: #FFF !important;
    color: #07213a !important
  }
}

.dropdown-item:last-child {
  border-bottom: none;
}

.card-infografis {
    padding: 1rem;
    border-radius: 1rem;
    box-shadow: 0px 2px 30px rgba(0, 0, 0, 0.1);
    background-color: #fff;
}

.dir-icon {
    height: 38px;
    object-fit: contain;
}

.bg-new {
    background-image: url('/public/assets/images/bg/bg-section-socmed.png') !important;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}

.directory-section {
    /* background: url(@/assets/media/images/bg/bg1.jpg) no-repeat;
    background-size: cover; */
    padding: 30px;
    /* background-color: #F8F7FF; */
    background-color: #FFF;
    height: 100vh;
}

.category-btn {
    border: 1px solid #ebebeb;
    margin: 26px 0 0;
    padding: 10px 25px 10px 25px;
    display: inline-block;
    font-size: 0.9rem;
    border-radius: 25px;
    background-color: #030F6B;
    color: #fff;
}

.category-btn:hover {
    background: #EDAF1F !important;
    color: #fff !important;
    border: 1px solid #EDAF1F !important;
}
</style>